import { FC } from "react";

import { HomeAboutRichParagraph, HomeAboutTextVariant } from "./content";

type HomeAboutRichTextProps = {
  segments: HomeAboutRichParagraph;
  className?: string;
};

/** Maps About story segment variants to layered highlighter strokes plus semantic color/weight. */
const variantClassName = (variant: HomeAboutTextVariant = "default"): string | undefined => {
  switch (variant) {
    case "accent":
      return "text-primaryDark-0 box-decoration-clone bg-primaryDark-400/25 px-0.5 py-px rounded-[2px]";
    case "emphasis":
      return "text-primaryDark-0 font-semibold box-decoration-clone bg-primaryDark-0/12 px-0.5 py-px rounded-[2px]";
    case "italic":
      return "italic text-slate-600 font-open-sans";
    case "resource":
      return "text-primaryDark-300 font-medium sm:text-[17px] font-raleway decoration-primaryDark-400/40 underline-offset-[3px] decoration-1";
    default:
      return undefined;
  }
};

/** Maps content segments to inline spans with layered rich-text styling for the About story. */
export const HomeAboutRichText: FC<HomeAboutRichTextProps> = ({ segments, className }) => (
  <span className={className}>
    {segments.map((segment, index) => {
      const highlightClass = variantClassName(segment.variant);

      return highlightClass ? (
        <span key={index} className={highlightClass}>
          {segment.text}
        </span>
      ) : (
        <span key={index}>{segment.text}</span>
      );
    })}
  </span>
);

export default HomeAboutRichText;
